export interface HumanizedDateParts {
  /** Dia do mês com 2 dígitos. Ex.: "01" */
  day: string;
  /** Mês do ano por extenso. Ex.: "Abril" */
  month: string;
  /** Ano completo. Ex.: "2013" */
  year: string;
  /** Dia da semana por extenso. Ex.: "Terça-feira" */
  dayOfTheWeek: string;
}

const months = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

const daysOfTheWeek = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
];

export function getDateParts(date: Date): HumanizedDateParts {
  const day = date.getDate().toString().padStart(2, '0');
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString();
  const dayOfTheWeek = daysOfTheWeek[date.getDay()];

  return {
    dayOfTheWeek,
    day,
    month,
    year,
  };
}

type DateInput = string | Date;

const getDateAsMilliseconds = (dateInput: DateInput): number => {
  let timeValue: number;

  if (typeof dateInput === 'string') {
    timeValue = Date.parse(dateInput);
  } else {
    timeValue = dateInput.getTime();
  }
  return timeValue;
};

export function getTimesInMilliseconds(dataInicio: DateInput, dataFim: DateInput):
{ timeInicio: number, timeFim: number } {
  const timeInicio = getDateAsMilliseconds(dataInicio);
  const timeFim = getDateAsMilliseconds(dataFim);

  return { timeInicio, timeFim };
}

/** dd/mm/aaaa -> ISO yyyy-mm-dd; null se inválida ou futura. */
export function birthDateToIso(value: string): string | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());
  if (!match) {
    return null;
  }

  const [, dayText, monthText, yearText] = match;
  const day = Number(dayText);
  const month = Number(monthText);
  const year = Number(yearText);
  const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const daysInMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (year < 1 || month < 1 || month > 12 || day < 1 || day > daysInMonth[month - 1]) {
    return null;
  }

  const iso = `${yearText}-${monthText}-${dayText}`;
  const today = new Date();
  const todayIso = [
    String(today.getFullYear()).padStart(4, '0'),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0'),
  ].join('-');

  return iso <= todayIso ? iso : null;
}

/** ISO yyyy-mm-dd -> dd/mm/aaaa; vazio quando não vem data. */
export function isoToBirthDate(value: string | null | undefined): string {
  const [ano, mes, dia] = (value ?? '').slice(0, 10).split('-');
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : '';
}
